export default __webpack_public_path__ + "static/media/1_step.59672880.svg";